// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3Xoi7","choiceBoxes":"toolbarselects_choiceBoxes__PwjJl","simpleField":"toolbarselects_simpleField__3Jf3v"};